import { api } from '.';

export function getMe(payload) {
  return api('GET', `/users/me`, payload);
}

export function resetPassword(payload) {
  return api('PATCH', `/users/reset-password`, payload, { lang: payload.lang });
}

export function getUserById(payload) {
  return api('GET', `/users/${payload.id}`, payload, { lang: payload.lang });
}

export function resetPasswordById(payload) {
  return api('PATCH', `/users/reset-password`, payload, { lang: payload.lang });
}

export function logout(payload) {
  return api('POST', '/auth/logout', payload);
}
